export class User {
  role = 'B2C'
  password?: string;
  email: string;
}
